import { CSS } from "../../constants/css";
import { isVisible } from "../../utils/dom";

const instance = ($el: HTMLElement) => {
  const dom = {
    $menu: $el.querySelectorAll<HTMLElement>(".js-menu"),
    $toggleBtn: $el.querySelector<HTMLElement>(".js-menu-toggle"),
    $menuItems: $el.querySelectorAll<HTMLElement>(".js-menu-item"),
    $dropdownToggles: $el.querySelectorAll<HTMLElement>(".js-dropdown-toggle"),
  };

  const DROPDOWN_ITEM = ".primary-navigation__list-item--has-dropdown";

  const setupListeners = () => {
    dom.$toggleBtn?.addEventListener("click", function () {
      toggle(this);
    });

    dom.$dropdownToggles.forEach(($toggle) => {
      $toggle.addEventListener("click", (event) => {
        event.preventDefault();
        toggleDropdown($toggle);
      });
    });

    document.addEventListener("click", (event) => {
      if (!$el.contains(event.target as Node)) {
        closeAllDropdowns();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeAllDropdowns();
      }
    });
  };

  const closeAllDropdowns = (except?: HTMLElement) => {
    dom.$dropdownToggles.forEach(($toggle) => {
      const $item = $toggle.closest<HTMLElement>(DROPDOWN_ITEM);
      if (!$item || $item === except) {
        return;
      }
      $item.classList.remove(CSS.active);
      $toggle.setAttribute("aria-expanded", "false");
    });
  };

  const toggleDropdown = ($toggle: HTMLElement) => {
    const $item = $toggle.closest<HTMLElement>(DROPDOWN_ITEM);
    if (!$item) {
      return;
    }
    const isOpen = $item.classList.contains(CSS.active);
    closeAllDropdowns($item);
    $item.classList.toggle(CSS.active, !isOpen);
    $toggle.setAttribute("aria-expanded", (!isOpen).toString());
  };

  const setupTabbability = () => {
    const burgerVisible = isVisible(dom.$toggleBtn); // mobile
    const burgerExpanded = dom.$toggleBtn?.getAttribute("aria-expanded") === "true";

    dom.$menuItems.forEach(($menuItem) => {
      if ((burgerVisible && burgerExpanded) || (!burgerVisible)) {
        $menuItem.removeAttribute("tabindex");
        return;
      }
      $menuItem.setAttribute("tabindex", "-1");
    });
  };

  const toggle = (el: HTMLElement) => {
    dom.$menu.forEach(($menu) => {
      $menu.classList.toggle(CSS.active);
    });
    dom.$toggleBtn?.classList.toggle(CSS.active);

    el.setAttribute("aria-expanded", el.getAttribute("aria-expanded") === "true" ? "false" : "true");
    setupTabbability();
  };

  setupListeners();
  setupTabbability();

  screen.orientation.addEventListener("change", setupTabbability);
  window.addEventListener("resize", setupTabbability);
};

export default () => {
  const $nav = document.querySelectorAll<HTMLElement>(".js-nav");

  $nav.forEach(($element) => {
    instance($element);
  });
};
